
let showDialog: (() => void) | null = null;

export const setShowBrokenLinkDialog = (fn: () => void) => {
  showDialog = fn;
};

export const triggerShowBrokenLinkDialog = () => {
  if (showDialog) showDialog();
};